import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "UiPlaceholder" }
const _hoisted_2 = {
  key: 0,
  class: "UiPlaceholder__icon"
}
const _hoisted_3 = { class: "UiPlaceholder__content" }
const _hoisted_4 = {
  key: 0,
  class: "UiPlaceholder__title"
}
const _hoisted_5 = {
  key: 1,
  class: "UiPlaceholder__description"
}
const _hoisted_6 = {
  key: 1,
  class: "UiPlaceholder__action"
}

import "./UiPlaceholder.css";

import { PropType } from "vue";

import { HeroIcons } from "../icon";

import UiIcon from "../icon/UiIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiPlaceholder',
  props: {
  icon: { type: String as PropType<HeroIcons> },
  iconSize: { type: Number, default: 64 },
  title: { type: String },
  description: { type: String },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.icon || __props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon", {}, () => [
            (__props.icon)
              ? (_openBlock(), _createBlock(UiIcon, {
                  key: 0,
                  size: __props.iconSize,
                  icon: __props.icon
                }, null, 8, ["size", "icon"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.$slots.action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "action")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})